import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import MealNutrition from './meal_nutrition';
import {
  foodAllergenLabel,
  foodPreferenceLabel,
} from '../../services/food_allergens_preferences';

const MealDetailNutrition = ({
  derivedNutrition,
  showNutritionMetrics,
  showMacroRatio,
  hideNutritionErrors,
}) => {
  const hasNutritionErrors = derivedNutrition?.status === false;

  return (
    <>
      <Typography variant="h3">Nutrition</Typography>
      <p className="mealNutritionDisclaimer">
        Please note these are estimated nutrition values
      </p>
      <MealNutrition
        totalNutritionPerServing={derivedNutrition?.totalNutritionPerServing}
        showNutritionMetrics={showNutritionMetrics}
        macroRatio={showMacroRatio && derivedNutrition?.macroRatio}
      />
      {!hideNutritionErrors && hasNutritionErrors && (
        <div style={{ display: 'flex', marginTop: '10px' }}>
          <div
            style={{
              margin: 'auto 0',
              color: 'orange',
            }}>
            <WarningIcon />
          </div>
          <div style={{ margin: 'auto 5px' }}>
            WARNING: some ingredients fields have not been recognised
          </div>
        </div>
      )}
      {!hasNutritionErrors && (
        <div style={{ marginTop: '10px' }}>
          {(derivedNutrition?.foodAllergens || []).map((foodAllergen) => (
            <Chip
              key={foodAllergen}
              label={foodAllergenLabel(foodAllergen)}
              variant="outlined"
              size="small"
            />
          ))}
          {(derivedNutrition?.foodPreferences || []).map((foodPreference) => (
            <Chip
              key={foodPreference}
              label={foodPreferenceLabel(foodPreference)}
              variant="outlined"
              size="small"
            />
          ))}
        </div>
      )}
    </>
  );
};

MealDetailNutrition.propTypes = {
  derivedNutrition: PropTypes.shape({
    totalNutritionPerServing: PropTypes.objectOf(PropTypes.number),
    // eslint-disable-next-line react/forbid-prop-types
    ingredientNutrition: PropTypes.arrayOf(PropTypes.object).isRequired,
    macroRatio: PropTypes.objectOf(PropTypes.number).isRequired,
    foodAllergens: PropTypes.arrayOf(PropTypes.string).isRequired,
    foodPreferences: PropTypes.arrayOf(PropTypes.string).isRequired,
    status: PropTypes.bool.isRequired,
  }).isRequired,
  showNutritionMetrics: PropTypes.arrayOf(PropTypes.string).isRequired,
  showMacroRatio: PropTypes.bool.isRequired,
  hideNutritionErrors: PropTypes.bool,
};

MealDetailNutrition.defaultProps = {
  hideNutritionErrors: false,
};

export default MealDetailNutrition;
